const sortByPerTravellerAmount = (a, b) =>
  a.charges.perTraveller.amount - b.charges.perTraveller.amount;

export const getCheapestFlightOption = (flightOptions) => {
  const sortedByLeastSegments = (direction) =>
    flightOptions[direction].sort(
      (a, b) => a.flightSegments.length - b.flightSegments.length,
    );

  const sortedByLeastSegmentsOutbound = sortedByLeastSegments('outbound');
  const sortedByLeastSegmentsInbound = sortedByLeastSegments('inbound');

  return {
    cheapestOutbound: sortedByLeastSegmentsOutbound
      .filter(
        (option) =>
          option.flightSegments.length ===
          sortedByLeastSegmentsOutbound[0].flightSegments.length,
      )
      .sort(sortByPerTravellerAmount)[0],
    cheapestInbound: sortedByLeastSegmentsInbound
      .filter(
        (option) =>
          option.flightSegments.length ===
          sortedByLeastSegmentsInbound[0].flightSegments.length,
      )
      .sort(sortByPerTravellerAmount)[0],
  };
};

export default getCheapestFlightOption;
